module.exports = __webpack_public_path__ + "static/falken-fa929089a3f68d82f94dcd167767bc94.png";